// import Amplify from 'aws-amplify';
// import awsconfig from './aws-exports';
// Amplify.configure(awsconfig);
import Home from "./components/Home"

import "./style/app.css"

export default function App() {
  return (
    <Home />
  );
}

